<div class="forecast-details-container">
    <div fxLayout="column" fxLayoutAlign="start center">
        <div fxFlex="nogrow" fxLayout="column" fxLayoutGap="6px">
            <div *ngIf="getEntity(forecast)|async as entity" fxLayoutAlign="space-between" fxLayoutGap="1rem">
                <div class="property">{{'Resource'|i18n}}</div>
                <div><em>{{entity.path|nicePath:false}}</em></div>
            </div>
            <div fxLayoutAlign="space-between" fxLayoutGap="1rem">
                <div class="property">{{'Created'|i18n}}</div>
                <div>{{forecast.forecast_timestamp|i18nTimestamp}}</div>
            </div>
            <div fxLayoutAlign="space-between" fxLayoutGap="1rem">
                <div class="property">{{'Time range'|i18n}}</div>
                <div>{{forecast.start_time|i18nTimestamp}} ÷ {{forecast.end_time|i18nTimestamp}}</div>
            </div>
            <div fxLayoutAlign="space-between" fxLayoutGap="1rem">
                <div class="property">{{'Strategy'|i18n}}</div>
                <div>{{(forecast|forecastStrategy) || ('Unknown'|i18n)}}</div>
            </div>
            <ng-container *ngIf="showModels">
                <div *ngIf="getModels(forecast) as models" fxLayoutAlign="space-between" fxLayoutGap="1rem">
                    <div class="property">{{'Models'|i18n}}</div>
                    <div>{{models}}</div>
                </div>
            </ng-container>
        </div>
    </div>
</div>
